import React from "react"
import PostList from "./PostList";
import SideBar from "./SideBar";

function PostsAndSideBar() {
    return (
        <div className="container-fluid">
            <div className="row">
                <PostList />
                <SideBar />
            </div>
        </div> 
    );
}

export default PostsAndSideBar;